import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { QueryResult } from '../../stores/dataStore';
import { InstructorRolesStore, InstructorRoleDto } from '../../stores/instructor-roles/instructor-roles-store';
import { SelectionInput } from '../form/selectionInput';
import { nameof } from '../../utils/object';
import { ItemReference } from '../../stores/dataStore';
import { isNullOrWhiteSpaces } from '../../utils/useful-functions';

interface InstructorRoleEditorProps extends WithTranslation {
  value: ItemReference;
  onChange: (value: ItemReference) => void;
  className?: string;
  placeholder?: string;
  instructorRoles?: InstructorRolesStore;
  nullable?: boolean;
  minWidth?: number;
  reloadOnChange?: boolean;
  readOnly?: boolean;
  clearable?: boolean;
  isPoC?: boolean;
}

interface InstructorRoleEditorState {
  value: ItemReference;
  query?: (searchQuery: string) => Promise<QueryResult<ItemReference>>;
}

@connect(['instructorRoles', InstructorRolesStore])
class InstructorRoleEditor extends React.Component<InstructorRoleEditorProps, InstructorRoleEditorState> {
  private get instructorRolesStore() {
    return this.props.instructorRoles;
  }

  constructor(props: InstructorRoleEditorProps) {
    super(props);
    this.state = {
      value: this.props.value,
      query: this.getInstructorRoles()
    };
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next !== this.props && next.value !== this.props.value && this.props.reloadOnChange) {
      this.setState({
        value: next.value,
        query: this.getInstructorRoles()
      });
    }
  }

  @autobind
  private getInstructorRoles() {
    const method = async (search: string) => {
      const result = await this.instructorRolesStore.getAllAsync({
        searchQuery: '',
        skip: 0,
        take: 100000,
        orderBy: [{ direction: 'Ascending', field: nameof<InstructorRoleDto>('name'), useProfile: false }],
        filter: isNullOrWhiteSpaces(search) ? [] : [`startswith(tolower(${nameof<InstructorRoleDto>('name')}), '${search.toLowerCase()}')`]
      });
      if (this.props.isPoC) {
        return Object.assign({}, result, {
          items: result.items.filter(x => x.name === 'Internal Trainer').map(c => ({ id: c.id, title: c.name }))
        }) as QueryResult<ItemReference>;
      } else {
        return Object.assign({}, result, { items: result.items.map(c => ({ id: c.id, title: c.name })) }) as QueryResult<ItemReference>;
      }
    };
    return method;
  }

  public render() {
    const val = this.state.value;
    const query = this.state.query;
    return (
      <SelectionInput
        content={item => <div>{item.title}</div>}
        searchable
        className={this.props.className}
        readOnly={this.props.readOnly}
        minWidth={this.props.minWidth}
        nullable={this.props.nullable}
        placeholder={this.props.placeholder}
        query={query}
        value={val}
        onChange={value => this.props.onChange(value as any)}
        clearable={this.props.clearable}
      />
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(InstructorRoleEditor);
